import { ulEdit05 } from '@faceup/icons/ulEdit05'
import { ulFileSearch02 } from '@faceup/icons/ulFileSearch02'
import { ulHomeLine } from '@faceup/icons/ulHomeLine'
import { useMatchPath, useNavigate } from '@faceup/router'
import { Institution } from '@faceup/utils'
import { type FragmentType, getFragmentData, graphql } from '../../../../__generated__'
import { ButtonItem, MobileFooterShell } from '../../../../Components/Footer/MobileFooterShell'
import { useInstitution } from '../../../../hooks/useInstitution'
import { useIsCheckReportAvailable } from '../../../../hooks/useIsCheckReportAvailable'
import { defineMessages, FormattedMessage } from '../../../../TypedIntl'

const messages = defineMessages({
  createReport: 'FollowUp.InstitutionLayout.createReport',
  checkReport: 'FollowUp.CheckReport.title',
  createReportForTestingSchool: 'FollowUp.InstitutionLayout.createReportForTestingSchool',
  home: 'FollowUp.InstitutionLayout.home',
})

const fragments = {
  AppFooter_reportSource: graphql(`
    fragment AppFooter_reportSource on PublicReportSource {
      id
      institution {
        id
        isTesting
        type
        billing {
          id
          plan
        }
      }
    }
  `),
}

type AppFooterProps = {
  reportSource: FragmentType<typeof fragments.AppFooter_reportSource>
}
export const AppFooter = ({ reportSource: _reportSource }: AppFooterProps) => {
  const reportSource = getFragmentData(fragments.AppFooter_reportSource, _reportSource)
  const { isCheckReportAvailable } = useIsCheckReportAvailable({
    plan: reportSource.institution?.billing?.plan,
  })
  const matchPath = useMatchPath()
  const institution = useInstitution()
  const navigate = useNavigate()

  const isTestingSchool =
    reportSource.institution.isTesting === true &&
    reportSource.institution.type === Institution.School

  const visibleMenuItems = [Boolean(institution?.homepage), true, isCheckReportAvailable]

  const countMenuItems = visibleMenuItems.filter(Boolean).length

  return (
    <MobileFooterShell itemCount={countMenuItems}>
      {institution?.homepage && (
        <ButtonItem
          onClick={() => navigate(institution.homepage)}
          active={Boolean(
            matchPath(routes => routes.page(), {
              wildcard: true,
            })
          )}
          icon={ulHomeLine}
        >
          <FormattedMessage {...messages.home} />
        </ButtonItem>
      )}
      <ButtonItem
        onClick={() => navigate(routes => routes.createReport())}
        active={
          Boolean(matchPath(routes => routes.createReport())) ||
          Boolean(matchPath(routes => routes.sentReport()))
        }
        icon={ulEdit05}
      >
        {isTestingSchool ? (
          <FormattedMessage {...messages.createReportForTestingSchool} />
        ) : (
          <FormattedMessage {...messages.createReport} />
        )}
      </ButtonItem>
      {isCheckReportAvailable && (
        <ButtonItem
          onClick={() => navigate(routes => routes.checkReport())}
          active={
            Boolean(matchPath(routes => routes.report())) ||
            Boolean(matchPath(routes => routes.checkReport(), { wildcard: true }))
          }
          icon={ulFileSearch02}
        >
          <FormattedMessage {...messages.checkReport} />
        </ButtonItem>
      )}
    </MobileFooterShell>
  )
}
